<template>
  <div class="p-3 bg-white">
    <shared-auto-call-system-upload-data
      @uploadSuccess="uploadSuccess"
    ></shared-auto-call-system-upload-data>

    <div class="text-right">
      <vs-button id="uploadButton" class="m-2" color="primary" type="filled" @click.prevent="upload">{{ $t('upload') }}</vs-button>
    </div>
    <br/>
    <vs-button class="m-2" color="success" type="filled" @click.prevent="downloadSample">{{ $t('download_sample') }}</vs-button>
  </div>
</template>

<script>
import SharedAutoCallSystemUploadData from '@/views/Shared/AutoCallSystemPublic/UploadData'
import { EventBus } from '@/../eventbus.js'
import AutoCallSystemPublic from '@/models/AutoCallSystemPublic'

export default {
  name: 'Window.AutoCallSystemPublic.Upload',
  components: {
    SharedAutoCallSystemUploadData
  },
  methods: {
    upload () {
      EventBus.$emit('initUploadAutoCallSystemPublicData')
    },
    async downloadSample (e) {
      e.preventDefault()
      try {
        this.language = this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.language : 'en'
        await AutoCallSystemPublic.downloadSampleImportFile(this.language)
      } catch (e) {
        this.$alertHelper.error()
      }
    },
    uploadSuccess () {
      this.$windowOpenerHelper.notifyOpener('reload_auto_call_system_public_table')
      window.close()
    },
    cancel () {
      this.$windowOpenerHelper.notifyOpener('reload_auto_call_system_public_table')
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
